import axios from 'axios'
import { getAccessToken, removeAccessToken } from 'src/services/common/storage'
import { searchUserAgent } from 'src/constants/userAgent'
import liff from '@line/liff'

const axiosInstanceV2 = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
})

const handleUnauthorized = () => {
  removeAccessToken()
  window.dispatchEvent(new Event('auth:logout'))
  window.dispatchEvent(new Event('storage'))

  if (
    typeof window !== 'undefined' &&
    window.location.pathname !== '/login' &&
    window.location.pathname !== '/login-line' &&
    window.location.pathname !== '/liff'
  ) {
    if (liff && typeof liff.isLoggedIn === 'function' && !liff.isLoggedIn()) {
      liff.login({ redirectUri: window.location.origin })
    } else {
      window.location.href = '/login-line'
    }
  }
}

axiosInstanceV2.interceptors.request.use(
  ($config) => {
    const token = getAccessToken()

    if (token) {
      $config.headers.Authorization = `Bearer ${token}`
    }
    $config.headers['Content-Type'] = 'application/json'
    $config.headers.Accept = 'application/json'
    $config.headers.device = searchUserAgent()
    return $config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstanceV2.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthError =
      error.response?.status === 401 ||
      error.response?.data?.errors === 'Authorization token required' ||
      error.response?.data?.error === 'Authorization token required'

    if (isAuthError) {
      handleUnauthorized()
    }

    return Promise.reject(error.response)
  }
)

export default axiosInstanceV2
